// The carrier list, in ONE place. mdf-bo-fn#237.
//
// Mirrors mdf-bo-api controllers/BO-ShippingProvider.go `SHIPPING_PROVIDERS`
// (id → name). Five pages used to carry their own copy of this table and four
// of them had drifted: id 5 read "มาดามฟิน เอ็กซ์เพรส" while the back-end says
// id 5 is DHL and มาดามฟิน is 6 — so ExpressForm, the one page that actually
// sends the chosen id, bound orders to DHL when the user picked มาดามฟิน.
//
// The back-end now serves this list at GET /api/v1/shipping-providers
// (asrth/mdf-bo-api#551). This module is the offline copy the dropdowns render
// from; tests/unit/shippingProviders.spec.js checks it against the Go table
// whenever the monorepo checkout is present, so a change on either side fails
// a build here instead of a parcel label in production.
//
// Keep ids and names IDENTICAL to the Go file. Do not reorder by taste — the
// order is the back-end's order.
export const SHIPPING_PROVIDERS = [
	{ id: 1, name: "ไปรษณีย์ไทย" },
	{ id: 2, name: "เคอรี่ เอ็กซ์เพรส" },
	{ id: 3, name: "นินจาแวน" },
	{ id: 4, name: "แฟลช เอ็กซ์เพรส" },
	{ id: 5, name: "DHL" },
	{ id: 6, name: "มาดามฟิน เอ็กซ์เพรส" },
	{ id: 7, name: "SPX" },
	{ id: 8, name: "Flash Express" },
	{ id: 9, name: "ขนส่งพิเศษ" },
];

// Ids the shipping forms offer. 3, 4 and 8 are carriers no longer in use
// (PackingTables.vue and MtSaleOrderDetail.vue already leave them out); 9 is
// the company van and belongs to the Modern Trade flow only.
export const SHIPPING_FORM_PROVIDER_IDS = [1, 2, 5, 6, 7];

export function shippingProviderName(id) {
	const p = SHIPPING_PROVIDERS.find((x) => x.id === Number(id));
	return p ? p.name : "";
}

export function shippingFormProviders() {
	return SHIPPING_PROVIDERS.filter((p) => SHIPPING_FORM_PROVIDER_IDS.includes(p.id));
}
